import { useQuery } from 'react-query'
import { useClient } from '@hooks/useClient'
import { useAuthentication } from '@hooks/useAuthentication'
import cn from 'classnames'
import { Typography } from '@features/sales/components/Typography'
import { ReportSummaryDetailProps } from './interface'

export function ReportSummaryDetail({
  className,
  searchParam,
}: ReportSummaryDetailProps) {
  const client = useClient()
  const { isAuthenticated } = useAuthentication()
  const { data: salesReportsOverview } = useQuery(
    ['sales-reports-overview', searchParam],
    () =>
      client?.saleClient.getSalesReportsOverview({
        searchParam,
      }),
    {
      enabled: isAuthenticated,
    }
  )
  const data = {
    downloadTotal: salesReportsOverview?.downloadTotal || 0,
    remainCoin: salesReportsOverview?.remainCoin || 0,
    salesSystem: salesReportsOverview?.salesSystem || 0,
    donateSystem: salesReportsOverview?.donateSystem || 0,
    shareSystem: salesReportsOverview?.shareSystem || 0,
    activeUser: salesReportsOverview?.activeUser || 0,
    salesTotal: salesReportsOverview?.salesTotal || 0,
    amountTotal: salesReportsOverview?.amountTotal || 0,
    donateTotal: salesReportsOverview?.donateTotal || 0,
  }
  return (
    <>
      <div
        className={cn(
          'flex justify-between text-[14px] font-light text-secondary-100 pb-[20px]',
          className
        )}
      >
        <Typography
          label='ยอดดาวน์โหลด'
          text={
            <span className='font-bold text-[24px]'>
              {data.downloadTotal.toLocaleString()}
            </span>
          }
        />
        {/* <Typography
          label='จำนวนเหรียญทองคงเหลือในระบบ'
          text={
            <span className='font-bold text-[24px]'>
              {remainCoin.toLocaleString()}
            </span>
          }
        /> */}
        <Typography
          label='ส่วนแบ่งยอดขายเข้าระบบ'
          text={
            <span className='font-bold text-[24px] text-secondary'>
              {data.salesSystem.toLocaleString()}
            </span>
          }
        />
        <Typography
          label='ส่วนแบ่งยอดสนับสนุนเข้าระบบ'
          text={
            <span className='font-bold text-[24px] text-secondary'>
              {data.donateSystem.toLocaleString()}
            </span>
          }
        />
        <Typography
          label='ส่วนแบ่งเข้าระบบทั้งหมด'
          text={
            <span className='font-bold text-[24px] text-primary'>
              {data.shareSystem.toLocaleString()}
            </span>
          }
        />
      </div>
      <div
        className={cn(
          'flex justify-between text-[14px] font-light text-secondary-100 py-[20px] border-y-[1px] border-gray'
        )}
      >
        <Typography
          row
          label='Daily active user'
          text={
            <span className='font-bold  text-secondary'>
              {data.activeUser.toLocaleString()}
            </span>
          }
        />
        <Typography
          row
          label='ยอดขาย'
          text={
            <span className='font-bold  text-secondary'>
              {data.salesTotal.toLocaleString()}
            </span>
          }
        />
        <Typography
          row
          label='ยอดซื้อตอนนี้'
          text={
            <span className='font-bold  text-secondary'>
              {data.amountTotal.toLocaleString()}
            </span>
          }
        />
        <Typography
          row
          label='ยอดสนับสนุน'
          text={
            <span className='font-bold  text-secondary'>
              {data.donateTotal.toLocaleString()}
            </span>
          }
        />
        <Typography
          row
          label='จำนวนเหรียญทองคงเหลือในระบบ'
          text={
            <span className='font-bold  text-secondary'>
              {data.remainCoin.toLocaleString()}
            </span>
          }
        />
      </div>
    </>
  )
}
